// extracted by mini-css-extract-plugin
export default {"Fullscreen":"Fullscreen_Fullscreen__ih3Be"};